import React from "react";
import {Order, OrderItem, Product} from "depoto-core";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useCore} from "../hooks";
import './ProductListRow.css'
import {ProductDescriptionColumn} from "./ProductDescriptionColumn.tsx";
import {updateBill} from "../utils";
import {ProductStockColumn} from "./ProductStockColumn.tsx";

type Props = {
  product: Product
}
export const ProductListRow: React.FC<Props> = ({ product }) => {

  const { currentOrder, setCurrentOrder } = useCore()

  const addProductToBill = () => {
    updateBill({ currentOrder, setCurrentOrder, product })
  }

  if (!product) {
    return null
  }

  return (
    <div className="flex flex-row product-list-row mb-1 bg-white p-2 h-row border-1 boder-solid border-border-light">
      <ProductDescriptionColumn product={product} areTagsShown={true} />
      <ProductStockColumn product={product} />
      <div className="flex flex-col justify-center">
        {/*this is div, not btn - resolves focused btn click on barcode read..*/}
        <div className="btn btn-primary btn-add" tabIndex={-1} onClick={addProductToBill}>
          <FontAwesomeIcon icon={'plus'} size="lg"/>
        </div>
      </div>
    </div>
  );
}
